import React, {useState} from 'react';

//import getOptionExpirationDatesObservable
  //  from '../../../../../rxjs/observables/incomingmessage/OptionExpirationDatesObservable';
import Select from 'react-select';
//import getApproxStrikesPerExpirationDatesObservable
  //  from '../../../../../rxjs/observables/incomingmessage/ApproxStrikesPerExpirationDateObservable';
import ApplyRounding from '../../../../../utils/math/ApplyRounding';
import {Typography} from '@material-ui/core';
import {
    requestApproxStrikesPerExpirationDate
} from '../../../../../stores/websocketStore/utils/outgoingMessages/optionexpirations/approxStrikesPerExpirationDate';
import {
    requestOptionExpirationDates
} from '../../../../../stores/websocketStore/utils/outgoingMessages/optionexpirations/requestOptionExpirationDates';
import {useWebsocketStore} from "../../../../../stores/websocketStore/websocketProvider";
import {filter, map} from "rxjs/operators";

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        fontSize: 10,
        //borderBottom: '1px dotted pink',
        color: state.isSelected ? 'red' : 'blue',
        //padding: 20,
    }),
    control: () => ({
        // none of react-select's styles are passed to <Control />
        width: 125,
        fontSize: 10,
    }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';

        return {...provided, opacity, transition};
    },
};

export default function SelectExpirationDates(props) {
    const {approxStrikesPerExpirationDateSubject, optionExpirationDatesSubject} = useWebsocketStore();
    return <SelectExpirationDatesComponent strikesSubject={approxStrikesPerExpirationDateSubject} dateSubject={optionExpirationDatesSubject} {...props}/>
}
class SelectExpirationDatesComponent extends React.Component {
    constructor(props) {
        super(props);
        this.key = 'optionExpirationDate' + new Date().getTime();

        this.datesObservable = props.dateSubject.pipe(filter((message) => message.key === this.key))
            .pipe(map((msg) => msg.dates));// getOptionExpirationDatesObservable(this.key);

        if (props.showStrikesMessage) {
            this.strikesObservable = props.strikesSubject.pipe(filter((message) => message.key === this.key))
                .pipe(map((msg) => msg));// getOptionExpirationDatesObservable(this.key);
        }
        this.dataSource = props.dataSource;
        this.brokerage = props.brokerage;
        this.symbol = props.symbol;
        this.state = {
            dates: [],
            hasRecievedDates: false,
            //   highBarrier: 0,
            // lowBarrier: 0,
        };
        this.expirationDates = props.expirationDates;
        this.setExpirationDates = props.setExpirationDates;
        this.expirationsAdded = 0;
        this.setWeeks = this.setWeeks.bind(this);
        this.chosenDates = [];
        this.alreadyRequested = false;
        this.notExpiringToday = props.notExpiringToday;
        //this.strikesPerExpirationDate = {};
    }

    componentDidMount() {
        this.datesSubscription = this.datesObservable.subscribe((value) => {
            this.setState({dates: []});
            let values = [];
            this.expirationDates = [];
            this.chosenDates = [];
            let index = 0;
            value.forEach((element) => {
                values.push({value: element, label: element});
                if (index++ < this.props.startingIndex) {
                    console.log('returning for value: ' + element);
                    return;
                }
                if (this.expirationsAdded < this.props.numOfDefaultSelected) {
                    console.log('adding value: ' + element);
                    this.expirationsAdded++;
                    this.expirationDates.push(element);
                    this.hasRecievedDates = true;
                    console.log(this.expirationsAdded);
                    console.log(this.props.numOfDefaultSelected);
                    if (this.expirationsAdded === this.props.numOfDefaultSelected) {
                        console.log('setting state for expiration dates');
                        this.setExpirationDates(this.expirationDates);
                    }
                    this.chosenDates.push({
                        value: element,
                        label: element,
                    });
                }
            });
            this.setState({hasRecievedDates: true});
            this.setState({dates: values});
            // requestApproxStrikesPerExpirationDate(
            //    this.key,
            ////    this.symbol,
            //   this.dataSource,
            //   this.expirationDates
            // );
            //this.props.setSymbolsUsed(approxSymbols);
        });
        if (this.props.showStrikesMessage) {
            this.strikesSubscription = this.strikesObservable.subscribe((msg) => {
                //console.log(msg);
                let strikes = msg['approxStrikes'];
                if (strikes !== undefined) {
                    strikes = parseInt(strikes);
                    this.props.setHighBarrier(ApplyRounding(msg.highBarrier, 2));
                    this.props.setLowBarrier(ApplyRounding(msg.lowBarrier, 2));
                }
            });
        }
        if (!this.alreadyRequested) {
            requestOptionExpirationDates(
                this.key,
                this.symbol,
                this.dataSource,
                this.notExpiringToday
            );
            this.alreadyRequested = true;
        }
    }

    componentWillUnmount() {
        this.datesSubscription.unsubscribe();
        if (this.props.showStrikesMessage) {
            this.strikesSubscription.unsubscribe();
        }
    }

    setWeeks(dates) {
        if (dates === undefined || dates === null) {
            this.setExpirationDates([]);
            this.chosenDates = [];
            //this.props.setSymbolsUsed(1);
            return;
        }
        let dateValues = [];
        this.chosenDates = dates;
        console.log(JSON.stringify(dates));
        console.log('setting weeks');
        if (Array.isArray(dates)) {
            dates.forEach((date) => {
                //  console.log("setting on an array");
                dateValues.push(date.value);
            });
        } else {
            //console.log("setting on an object");
            dateValues.push(dates.value);
        }
        //console.log("date values: " + dateValues)
        this.setExpirationDates(dateValues);
        this.props.setOptionChains({});
        requestApproxStrikesPerExpirationDate(
            this.key,
            this.symbol,
            this.dataSource,
            dateValues,
            this.brokerage,
        );
    }

    render() {
        if (
            this.symbol !== this.props.symbol ||
            this.dataSource !== this.props.dataSource ||
            this.notExpiringToday !== this.props.notExpiringToday
        ) {
            this.symbol = this.props.symbol;
            this.dataSource = this.props.dataSource;
            this.notExpiringToday = this.props.notExpiringToday;
            this.expirationsAdded = 0;
            requestOptionExpirationDates(
                this.key,
                this.symbol,
                this.dataSource,
                this.notExpiringToday
            );
        }
        return !this.props.hideSelect && this.state.hasRecievedDates ? (
            <div>
                <Typography style={{fontSize: 12}}>
                    Available Expiration Dates
                </Typography>
                <Select
                    styles={customStyles}
                    closeMenuOnSelect={false}
                    isMulti={this.props.isMulti}
                    options={this.state.dates}
                    value={this.chosenDates}
                    onChange={this.setWeeks}
                />
                {/*  {(this.dataSource === "LIVE" && this.props.showStrikesMessage === true) ? (
                    <div>
                        <Typography style={{fontSize: 12}}>
                            tracking options between: {this.props.lowBarrier} and{" "}
                            {this.props.highBarrier}
                        </Typography>
                    </div>
                ) : (
                    <div></div>
                )} */}
            </div>
        ) : (
            <div></div>
        );
    }
}
/*

export default function SelectExpirationDates1({
                                                   symbol,
                                                   dataSource,
                                                   expirationDates,
                                                   setExpirationDates,
                                                   notExpiringToday,
                                                   symbolsUsed,
                                                   setSymbolsUsed,
                                                   isMulti,
                                                   numOfDefaultSelected,
                                                   setOptionChains,
                                                   startingIndex,
                                                   showStrikesMessage,
                                                   highBarrier,
                                                   setHighBarrier,
                                                   lowBarrier,
                                                   setLowBarrier
                                               }
) {
    const key = 'optionExpirationDate' + new Date().getTime();

    const {approxStrikesPerExpirationDateSubject, optionExpirationDatesSubject} = useWebsocketStore();
    let strikesObservable=null;
    const [dates, setDates]= useState([]);
    const [hasReceivedDates, setHasReceivedDates]= useState([]);

    useEff

    if(showStrikesMessage) {
        strikesObservable = approxStrikesPerExpirationDateSubject.pipe(filter((message) => message.key === key)).pipe(map((msg) => msg));
    }
    const datesObservable = approxStrikesPerExpirationDateSubject.pipe(filter((message) => message.key === key)).pipe(map((msg) => msg));
}
 */